export default __webpack_public_path__ + "static/niche@2x-6cf2d33cc7b8d070bcd81f419aa7a117.webp";